<template>
  <v-col cols="12">
    <div style="width: 100%; height: 100%;">
      <canvas
        ref="trendChart"
        height="100"
        :class="{ 'd-none': !hasData }"
      ></canvas>
      <div v-if="!hasData" class="d-flex">
        <v-img :src="$images.NO_TREND_LINE" :width="50" contain></v-img>
        <div class="my-auto pl-2 lighttext--text">
          <div class="subtitle-2">
            Not enough data to display trend line
          </div>
          <div class="caption">
            Change date range or wait for more data
          </div>
        </div>
      </div>
    </div>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Chart from "chart.js";
export default {
  name: "CoreCardTrend",
  props: { coreCard: { type: Object } },
  watch: {
    coreCard() {
      let self = this;
      setTimeout(function() {
        self.updateChart();
      }, 200);
    },
    business_metrics_trend() {
      let self = this;
      setTimeout(function() {
        self.updateChart();
      }, 200);
    }
  },
  computed: {
    isEngagement() {
      return this.coreCard.type == this.$enums.coreCardTypes.ENGAGEMENT;
    },
    isFeedback() {
      return this.coreCard.type == this.$enums.coreCardTypes.ANONYMOUS_FEEDBACK;
    },
    yMax() {
      return this.isEngagement ? 105 : 11;
    },
    yMin() {
      return -1;
    },
    value() {
      return this.isEngagement
        ? this.$coreScores.reverseFormat(this.coreCard.percentComplete)
        : this.coreCard.value;
    },
    hasData() {
      if (!this.datasets) {
        return false;
      }
      return (
        this.datasets.map(x => x.data.length).filter(x => x > 2).length > 0
      );
    },
    showBusinessMetrics() {
      return this.business_metrics_trend.length;
    },
    datasets() {
      let primary = this.coreCard.trend.map(x => {
        return { t: x.date, y: x.value };
      });
      let list = [
        {
          yAxisID: 1,
          data: primary,
          fill: true,
          backgroundColor: this.$coreScores.getColorBackground(this.value),
          borderColor: this.$coreScores.getColor(this.value)
        }
      ];

      if (this.showBusinessMetrics) {
        list.push({
          yAxisID: 2,
          data: this.business_metrics_trend
            .filter(x => x.value != null)
            .map(x => {
              return { t: x.date, y: x.value };
            }),
          fill: false,
          borderColor: this.$vuetify.theme.themes.light.secondarytext,
          label: this.business_metric.name,
          borderDash: [4, 5],
          borderWidth: 2
        });
      }
      return list;
    },
    lastDatasetIndex() {
      return this.datasets.length - 1;
    },
    ...mapGetters({
      business_metrics_trend: "reporting/business_metrics_trend",
      business_metric: "reporting/business_metric"
    })
  },
  mounted() {
    if (this.coreCard) {
      this.updateChart();
    }
  },
  methods: {
    updateChart() {
      let self = this;
      Chart.defaults.global.defaultFontColor = this.$vuetify.theme.themes.light.secondarytext;
      Chart.defaults.global.defaultFontSize = 10;
      if (this.chart) {
        this.chart.destroy();
      }
      if (!this.hasData) {
        return;
      }

      let yAxes = [
        {
          id: 1,
          ticks: {
            display: false,
            min: self._.minBy(this.coreCard.trend, "value").value - 1,
            max: self._.maxBy(this.coreCard.trend, "value").value + 1
          },
          gridLines: {
            display: false,
            drawTicks: false,
            drawOnChartArea: false
          }
        }
      ];

      if (this.showBusinessMetrics) {
        yAxes.push({
          id: 2,
          position: "right",
          ticks: {
            display: false,
            max: self._.maxBy(this.business_metrics_trend, "value").value + 1,
            min: self._.minBy(this.business_metrics_trend, "value").value - 1
          },
          gridLines: {
            display: false,
            drawTicks: false,
            drawOnChartArea: false
          }
        });
      }

      this.chart = new Chart(this.$refs.trendChart, {
        type: "line",
        data: {
          datasets: this.datasets
        },
        options: {
          layout: { padding: { top: 5, bottom: 5, right: 5, left: 5 } },
          legend: { display: false },
          tooltips: {
            model: "index",
            intersect: false,
            displayColors: false,
            titleAlign: "center",
            bodyAlign: "center",
            callbacks: {
              title: function(tooltipItem) {
                return moment(tooltipItem[0].label).format("MM/DD/YYYY");
              },
              label: function(tooltipItem) {
                if (
                  self.showBusinessMetrics &&
                  tooltipItem.datasetIndex == self.lastDatasetIndex
                ) {
                  switch (self.business_metric.unitId) {
                    case 1:
                      return self.$options.filters.currencyBig(
                        tooltipItem.value
                      );
                    case 2:
                      return tooltipItem.value + "%";
                  }
                  return tooltipItem.value;
                }
                if (self.isEngagement) {
                  return `${Number(tooltipItem.value).toFixed(1)}%`;
                } else if (self.isFeedback) {
                  return `${Number(tooltipItem.value).toFixed(0)} submitted`;
                }
                return `Score: ${Number(tooltipItem.value).toFixed(1)}`;
              },
              labelTextColor: function(tooltipItem) {
                if (
                  (tooltipItem.datasetIndex == self.lastDatasetIndex &&
                    self.showBusinessMetrics) ||
                  self.isFeedback
                ) {
                  return "white";
                }
                return self.$coreScores.getColor(Number(tooltipItem.value));
              }
            }
          },
          elements: {
            point: {
              radius: 0
            }
          },
          scales: {
            yAxes: yAxes,
            xAxes: [
              {
                gridLines: {
                  display: false,
                  drawTicks: false,
                  drawOnChartArea: false
                },
                type: "time",
                ticks: {
                  display: false
                },
                time: {
                  unit: "day",
                  unitStepSize: 1
                }
              }
            ]
          },
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              display: false
            }
          }
        }
      });
    }
  }
};
</script>
